import type { SkedEnvConfig } from "./types";

const config: SkedEnvConfig = {
  resourceUrl: "/assets/",
  apiBaseUrl: "", // Same origin, proxied by the Vite dev server
  fbAppId: "177460866310014",
  fbGraphApiVersion: "v25.0",
  fbBusinessLoginAppId: undefined,
  fbBusinessLoginConfigId: undefined,
  sendBirdAppId: "13069A74-7FB0-45D9-BC05-B2DF4F172307",
  amplitudeKey: "a3e1cb4cfcaca82c2ec8603b4734cfbe", // Empty for dev - analytics disabled locally
  amplitudeExperimentDeploymentKey: "",
  hubspotId: "44300864",
  bingPixelId: "17420662",
  linkedInPartnerId: "478874",
  pinterestTagId: "2613969021991",
  googleAdsId: "AW-992177465",
  ga4MeasurementId: "",
  gtmContainerId: "",
  bugsnagApiKey: "8f449d48646c0c521405dbb8b900217d",
  canvaApiKey: "fG32Ux1dYsPxhWU6QraYRH4x",
  dropboxAppKey: "7cwt9g746b3z3qa",
  chargebeeEnabled: true,
  analyticsEnabled: false, // Disable analytics in dev
  observabilityEnabled: false,
  observabilityEndpoint: "",
  observabilityHeaders: {},
  observabilitySampleRate: 0,
  rumClientToken: "",
  rumOrgIdentifier: "",
  rumSessionSampleRate: 0,
  rumSessionReplaySampleRate: 0,
  knockApiKey: null, // Disable Knock in dev - no valid user tokens available
  cesdkAssetsUrl: `${window.location.origin}/assets/resources/build/cesdk-assets`,
  googleDriveClientId:
    "981158975333-vohjljfs1jsn9sim09n4op4u5t0qpm40.apps.googleusercontent.com",
  googleDriveAppId: "981158975333",
  pusherApiKey: "5cce5f1404af15286506",
  pusherCluster: "mt1",
  insightsApiBaseUrl: "/insights-api/api",
};

export default config;
